import { useState } from 'react';

/**
 * @param {boolean} isDraft
 * @param {boolean} isEditing
 * @param {boolean} isComplete
 * @returns {boolean}
 */
const getInitialCollapsedState = (isDraft, isEditing, isComplete) => {
  if (!isDraft || isEditing || isComplete) {
    return false;
  }
  return true;
};

/**
 * @param {boolean} isDraft
 * @param {boolean} isEditing
 * @param {boolean} isComplete
 * @returns {[boolean, (isCollapsed: boolean) => void]}
 */
export const useIsStepCollapsed = (isDraft, isEditing, isComplete) => {
  return useState(getInitialCollapsedState(isDraft, isEditing, isComplete));
};
